import { Component, OnInit, OnDestroy, ViewChild, ElementRef, ViewChildren, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { MasonryItemModel } from '../masonry/masonry.component';
import { SiteService } from '../../services/site.service';
import { ActivatedRoute, Router } from '@angular/router';
import { getQueryParamFromAncestorRoute } from '../../utilities/route.utilities';
import { AverageConsumptionGridItemComponent } from './grid-item/average-consumption-grid-item.component';
import { ConsumptionService } from '../../services/consumption.service';
import { ReadDataAvailabilityGridItem } from './grid-item/read-data-availability-grid-item.component';
import { TotalConsumptionGridItem } from './grid-item/total-consumption-grid-item.component';
import swal from 'sweetalert2';
import { Validators, UntypedFormGroup, UntypedFormBuilder, FormControl, AbstractControl } from '@angular/forms';
import { CollapsibleDirective } from '../../directives/collapsible.directive';
import { DataService } from '../../services/data.service';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe'
import * as moment from 'moment';

@Component({
    selector: 'meter-portfolio',
    templateUrl: './meter-portfolio.component.html',
})
export class MeterPortfolioComponent implements OnInit, OnDestroy {

    subscriptions: Subscription[] = [];
    masonryItems: MasonryItemModel[] = [];
    clientId: number;
    sites: any[] = [];
    selectedSiteId: number = 0;
    selectedSupplyType: string;
    readDataSelectedSupplyType: string;
    paygConsumersPercentage: number = 0;
    websiteUsersPercentage: number = 0;
    isDecreasing: boolean = false;
    isIncreasing: boolean = false;
    filterList: any[] = [];
    filter: any[] = [];
    readDataFilterList: any[] = [];
    readDataFilter: any[] = [];
    supplyTypesData: any[] = [];
    averageConsumption: any;
    userSiteId: number = 0;
    documentData: string;
    documentStartDate: string; // YYYY/MM/DD format   
    documentStartEnd: string;  // YYYY/MM/DD format
    totalRegisters: number = 0;
    newRegistersLy: number = 0;
    newRegistersTy: number = 0;
    isReadDataCollapsed: boolean = true;
    form: UntypedFormGroup;
    submitted: boolean = false;
    submitting: boolean = false;
    dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
    dateAutoCorrectPipe = createAutoCorrectedDatePipe('dd/mm/yyyy');
    @ViewChild('timePeriod', { static: true }) timePeriod: ElementRef;
    @ViewChild('siteId', { static: true }) siteId: ElementRef;
    @ViewChildren(CollapsibleDirective) collapsible;

    constructor(private fb: UntypedFormBuilder,
        private siteService: SiteService,
        private consumptionService: ConsumptionService,
        private route: ActivatedRoute,
        private dataService: DataService,
        private router: Router,
        private cdRef: ChangeDetectorRef
    ) {
        this.form = this.fb.group({
            'startDate': [null, Validators.compose([Validators.required, Validators.maxLength(200)])],
            'endDate': [null, Validators.compose([Validators.required, Validators.maxLength(200)])],
            'supplyType': ['all', Validators.compose([Validators.required, Validators.maxLength(200)])],
            'meterType': ['all', Validators.compose([Validators.required, Validators.maxLength(200)])],
            'siteId': [null, Validators.compose([Validators.required, Validators.maxLength(200)])]
        });
    }

    ngOnInit() {
        this.masonryItems = [
            {
                component: AverageConsumptionGridItemComponent
            },
            {
                component: TotalConsumptionGridItem
            },
            {
                component: ReadDataAvailabilityGridItem
            },
        ];

        this.subscriptions.push(this.route
            .parent!
            .params
            .subscribe(params => {
                this.clientId = +params['clientId'];
                this.search();
            }));

        this.userSiteId = parseInt(getQueryParamFromAncestorRoute(this.route, 'siteId'));
        if (Number.isNaN(this.userSiteId) || this.userSiteId === undefined) { this.userSiteId = 0; }
        let timePeriod = 12;
        if (this.route.snapshot.queryParams['timePeriod']) {
            this.timePeriod.nativeElement.value =
                parseFloat(this.route.snapshot.queryParams['timePeriod']);
        } else {
            this.updateTimeperiod(timePeriod);
        }

        let siteId: number = 0;
        if (this.route.snapshot.queryParams['siteId']) {
            this.selectedSiteId = this.userSiteId;
            this.getMeterSummaryInfo(true, true);
        } else {
            this.updateSite();
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    updateTimeperiod(value: any) {
        let queryParams: any = JSON.parse(JSON.stringify(this.route.snapshot.queryParams)) as any;
        queryParams.timePeriod = +value;
        this.router.navigate(['/portal/' + this.clientId.toString() + '/meter'], { queryParams: queryParams, replaceUrl: true });
    }

    updateSite() {
        let queryParams: any = JSON.parse(JSON.stringify(this.route.snapshot.queryParams)) as any;
        if (this.selectedSiteId != undefined && this.selectedSiteId != null) queryParams.siteId = +this.selectedSiteId;
        this.getMeterSummaryInfo(true, true);
        this.router.navigate(['/portal/' + this.clientId.toString() + '/meter'], { queryParams: queryParams, replaceUrl: true });
    }

    updateSupplyCategory(supplyCategory: string) {
        this.getMeterSummaryInfo(false, false);
        let queryParams: any = JSON.parse(JSON.stringify(this.route.snapshot.queryParams)) as any;
        queryParams.supplyCategory = this.selectedSupplyType;
        this.router.navigate(['/portal/' + this.clientId.toString() + '/meter'], { queryParams: queryParams, replaceUrl: true });
    }

    filterUpdated(index: number = 0) {
        if (this.filterList.length > 0 && this.filterList.length == 1) { this.filterList[index].isClicked = true; return; }
        this.filter = [];
        this.filter.push(this.filterList[index].key);
        for (let i = 0; i < this.filterList.length; i++) {
            this.filterList[i].isClicked = false;
        }
        this.filterList[index].isClicked = !this.filterList[index].isClicked;
        if (this.filterList[index].isClicked) this.selectedSupplyType = this.filterList[index].label;
        this.updateSupplyCategory(this.filterList[index].label[0]);
    }

    unique = (value, index, self) => {
        return self.indexOf(value) === index;
    }

    firstLetterToLower(item: string) {
        return item.charAt(0).toLowerCase() + item.slice(1);
    }

    search(siteId?: number) {
        this.siteService.all(this.clientId).then((result) => {
            this.sites = result;
            if (this.sites.length == 1) {
                this.form.controls.siteId.setValue(this.sites[0].siteId.toString());
            }
        });
    }

    getMeterSummaryInfo(updateFilterList: boolean, getAllSuplyTypes: boolean) {
        let supplyType = this.selectedSupplyType;
        if (updateFilterList) {
            if (getAllSuplyTypes) { supplyType = null; }

            this.consumptionService.getMetersSummary(this.clientId, supplyType, this.selectedSiteId).then((result) => {
                // call to get all supply types
                this.averageConsumption = result;
                this.supplyTypesData = [];
                //get unique supply types
                this.supplyTypesData = this.averageConsumption.map(item => {
                    return item.supplyName
                }).filter(this.unique);

                this.filterList = [];
                this.readDataFilterList = [];
                this.filterList = this.supplyTypesData.map(items => {
                    // if not array convert to array
                    if (items && items.constructor !== Array) {
                        let temp = items;
                        items = [];
                        items[0] = temp;
                    }

                    return {
                        key: items.map(this.firstLetterToLower),
                        label: items,
                        isClicked: false
                    }
                });

                this.readDataFilterList.push({
                    key: 'all',
                    label: 'All',
                    isClicked: false
                });
                for (let i = 0; i < this.filterList.length; i++) {
                    this.readDataFilterList.push(this.filterList[i]);
                }
                this.readDataFilterList[0].isClicked = true;
                this.filterList[0].isClicked = true;
                this.selectedSupplyType = this.filterList[0].label[0];
                this.updateSupplyCategory(this.selectedSupplyType);
            }).catch(reason => { });
        }

        this.consumptionService.getMetersSummary(this.clientId, this.selectedSupplyType != null ? this.selectedSupplyType : "", this.selectedSiteId).then((result) => {
            this.totalRegisters = result[0].totalRegisters;
            this.newRegistersLy = result[0].newRegistersLy;
            this.newRegistersTy = result[0].newRegistersTy;

        }).catch(reason => {
            // if get summary fails set to 0
            this.totalRegisters = 0;
            this.newRegistersLy = 0;
            this.newRegistersTy = 0;
        });
    }

    download(content, fileName, contentType) {
        // if form incomplete don't download file
        if (this.form.controls.startDate.value == null && this.form.controls.startDate.value == '' &&
            this.form.controls.endDate.value == null && this.form.controls.endDate.value == '') { return; }

        var a = document.createElement("a");
        let file = new Blob([content], { type: contentType });
        a.href = URL.createObjectURL(file);
        a.download = fileName;
        a.click();
    }

    submit(form: UntypedFormGroup) {
        this.submitted = true;

        let startDateMoment = moment(form.value.startDate, 'DD-MM-YYYY');
        let endDateMoment = moment(form.value.endDate, 'DD-MM-YYYY');

        if (!startDateMoment.isValid || startDateMoment.year() < 2008) {
            form.controls.startDate.setErrors({
                'date': true
            });
        }

        if (!endDateMoment.isValid || endDateMoment.year() < 2008) {
            form.controls.endDate.setErrors({
                'date': true
            });
        }

        if (form.invalid) return;
        this.submitting = true;
        form.disable();

        let bulkType = "";
        if (form.value.meterType === "all") {
            bulkType = form.value.meterType;
        } else {
            bulkType = form.value.meterType == "domestic" ? "0" : "1"
        }

        let startDate = startDateMoment.format('YYYY-MM-DD');
        let endDate = endDateMoment.format('YYYY-MM-DD');

        // download document
        this.consumptionService.getDocumentData(form.value.siteId, startDate, endDate, form.value.supplyType, bulkType).then(
            result => {
                this.submitting = false;
                form.enable();
                this.documentData = result as any;
                let downloadfileName = startDate + '_' + endDate + '_' + form.value.supplyType + '.csv';            
                this.download(this.documentData, downloadfileName, 'text/csv');                
            },
            error => {
                this.submitting = false;
                form.enable();
            }
        );
    }

    onInfoClick() {
        swal({
            title: 'Download meter readings',
            html: '<p style="text-align: left;">This feature allows you to download a CSV file containing all readings within your required timeframe of up to two years.</p>\
            <p style="text-align: left;">Please note, requesting lots of data may take a few minutes to download.</p>\
            <p style="text-align: left;">You can continue to use Your.Switch2 in the meantime with the download waiting for you when it is ready.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
